// extracted by css-extract-rspack-plugin
export default {"noPaddingOnNarrow":"ModelLayout-module__noPaddingOnNarrow__VG4SK","contentPaddingOnNarrow":"ModelLayout-module__contentPaddingOnNarrow__JGCz3"};